import * as router from './router.actions';
import * as ui from './ui.actions';

export { router as routerActions, ui as uiActions };



// WEBPACK FOOTER //
// ./src/app/shared/store/actions/index.ts